import { AbstractControl, Validators } from "@angular/forms";
import { CpfValidator } from "../cpf/cpf";
import { CnpjValidator } from "../cnpj/cnpj";

export class DocumentValidator {

    static isValid(control: AbstractControl): { [key: string]: boolean } | null {
        const value = control.value;

        if (!value) return null;

        const raw = String(value).replace(/[.\-/]/g, '').toUpperCase();
        const hasLetter = /[A-Z]/.test(raw);

        if (!hasLetter && raw.length <= 11) {
            return CpfValidator.isValid(control);
        } else {
            return CnpjValidator.isValid(control);
        }
    }
}